import { Injectable } from '@angular/core';
import { User } from '../dashboard/pages/users/user';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';


    interface Global{
		[id: string]: any;
	}


@Injectable()
export class GlobalDataService {
	 // globalVarUpdate: Observable<string>;
     // globalVarObserver: Observer;
     // 
	 // subject = new BehaviorSubject<any>("");
	 user: User; 
	 isNeedNotificate: boolean = false;
	 soldDayCache:string;
	 soldMonthCache:string;
	 soldYearCache:string;
	 currencyRate:any={};
	 permissions: any={};
	 page:any={};
	 filter:any={};
	 type:string="";
	 data: Global = {};
	 //httpUrl: string = "http://10.0.75.1/api/v1/";
	 httpUrl: string = "https://api.crm-ekopen.ru/api/v1/";
    //httpUrl: string = "http://test.kamol2xi.bget.ru/api/v1/";
	 
	 constructor(private http: Http){
	}
	
	private subject = new Subject<any>();
	private subjectNotification = new Subject<any>();
	
    sendMessageNotification(message: string){
		this.subjectNotification.next({text: message});
	}

	getMessageNotification(): Observable<any>{
		return this.subjectNotification.asObservable();
	}

	sendMessage(message: string){
		this.subject.next({text: message});
	}

	clearMessage(){
		this.subject.next();
	}

	getMessage(): Observable<any>{
		return this.subject.asObservable();
	}

	refreshToken(){
		let headers = new Headers(),authtoken = localStorage.getItem('token');
        headers.append("Authorization", 'Bearer' + authtoken);
        headers.append('X-Requested-With', 'XMLHttpRequest');
        headers.append('Content-Type', 'application/json;');
		return this.http.get(this.httpUrl+'token',{headers: headers}).map((response: Response)=>{response.json()});
	}	
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/services/global-data.service.ts